
  function isScrolledIntoView2(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();
docViewBottom = docViewBottom-($(window).height()/2)+($(elem).height())+100;
    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom));
}

$(window).scroll(function () {
    $('.el-time-animation-grid-item').each(function () {
        if (isScrolledIntoView2(this) === true) {
            $(this).addClass('el-active');
        } else {
          $(this).removeClass('el-active');
        }
    });
    $('.el-timeline2-grid-item').each(function () {
        if (isScrolledIntoView2(this) === true) {
            $(this).addClass('el-active');
        } else {
          $(this).removeClass('el-active');
        }
    });
});
